<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Partial Delivery Update</h1>
<div mat-dialog-content>
    <form [formGroup]="partialUpdateDeliveryForm" *ngIf="partialUpdateDeliveryForm" (ngSubmit)="onSubmit()">
        <div class="delivery-colle-data-box">
            <fieldset>
                <legend>LISTINO:</legend>

                    <!--Billable field-->
                    <div class="col-48 grid-element">
                        <label for="billable"></label>
                        <label class="original-label">
                            <input type="checkbox" name="billable" formControlName="billable" (change)="handleBillable($event)">
                            DA FATTURARE
                        </label>
                    </div>

                    <div class="col-48 grid-element">
                        <label>Plus Prezzo</label>
                        <input type="number" formControlName="additionalPrice">
                    </div>
                    <!--Billable field-->

                    <!--Payable field-->
                    <div class="col-48 grid-element">
                        <label for="payable"></label>
                        <label class="original-label">
                        <input type="checkbox" name="payable" formControlName="payable" (change)="handlePayable($event)">
                        DA PAGARE
                        </label>
                    </div>

                    <div class="col-48 grid-element">
                        <label>VALET SALARIO PLUS MINUS PREZZO</label>
                        <input type="number" formControlName="valetAdditionalPrice">
                    </div>
                    <!--Payable field-->

            </fieldset>
        </div>
    </form>
</div>

<div mat-dialog-actions>
    <div class="btn-submit">
        <button mat-button class="btn" [disabled]="disableBtn" (click)=onSubmit()>Salva<i class="ml-10 far fa-save"></i></button>
    </div>
</div>